import aws from "./aws";
import servicecloud from "./servicecloud";

const graph = {
    aws,
    servicecloud,
};

export default graph;